import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default from 'react';
import TablePaginationWrapper from './Advanced/TablePaginationWrapper.js';
import TableBody from './Simple/TableBody.js';
import TableData from './Simple/TableData.js';
import TableHead from './Simple/TableHead.js';
import TableHeader from './Simple/TableHeader.js';
import TableRow from './Simple/TableRow.js';
import { TableSimple } from './Simple/TableSimple.js';

var _excluded = ["alternateRowColor", "cellPadding", "className", "children", "data-testid", "data", "fixedHeader", "height", "pagination", "name", "onSort", "rowSelection", "scrollableWidth", "showGrid", "width", "type"];
var Table = function Table(_ref) {
  var _Object$values;
  var alternateRowColor = _ref.alternateRowColor,
    _ref$cellPadding = _ref.cellPadding,
    cellPadding = _ref$cellPadding === void 0 ? 'normal' : _ref$cellPadding,
    className = _ref.className,
    children = _ref.children,
    dataTestId = _ref['data-testid'],
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data,
    fixedHeader = _ref.fixedHeader,
    height = _ref.height,
    pagination = _ref.pagination,
    name = _ref.name,
    onSort = _ref.onSort,
    rowSelection = _ref.rowSelection,
    scrollableWidth = _ref.scrollableWidth,
    showGrid = _ref.showGrid,
    width = _ref.width;
    _ref.type;
    var otherProps = _objectWithoutProperties(_ref, _excluded);
  var tableTypeIsAdvanced = (Object === null || Object === void 0 ? void 0 : (_Object$values = Object.values(data)) === null || _Object$values === void 0 ? void 0 : _Object$values.length) > 1;
  if (tableTypeIsAdvanced && children) {
    console.error("Hey Canvas User! You can't pass in both children and data to the table. Pick one.");
  }
  if (tableTypeIsAdvanced && typeof height === 'string') {
    console.error("Hey Canvas User! The new table (using data param) requires height to be a pixel number value not a string");
  }
  if (tableTypeIsAdvanced) {
    return /*#__PURE__*/React__default.createElement(TablePaginationWrapper, _extends({
      alternateRowColor: alternateRowColor,
      cellPadding: cellPadding,
      className: className,
      dataTestId: dataTestId,
      data: data,
      fixedHeader: fixedHeader,
      height: height,
      name: name,
      rowSelection: rowSelection,
      showGrid: showGrid,
      scrollableWidth: scrollableWidth,
      pagination: pagination
      //notice width is removed in the new table
    }, otherProps));
  }
  return /*#__PURE__*/React__default.createElement(TableSimple, _extends({
    alternateRowColor: alternateRowColor,
    cellPadding: cellPadding,
    className: className,
    children: children,
    dataTestId: dataTestId,
    height: height,
    name: name,
    onSort: onSort,
    width: width
  }, otherProps));
};
Table.displayName = 'Table';
Table.Body = TableBody;
Table.Data = TableData;
Table.Head = TableHead;
Table.Header = TableHeader;
Table.Row = TableRow;

export { Table as default };
